var _a;
import { LapsedClientsDescription, NewClientsDescription, ProspectiveClientsDescription, RegularClientsDescription, } from '../types';
import { DefaultSegmentName } from '../../../../../../../types/audience-segments';
export var getSegmentDescription = function (segmentName) {
    switch (segmentName) {
        case DefaultSegmentName.new:
            return NewClientsDescription;
        case DefaultSegmentName.regular:
            return RegularClientsDescription;
        case DefaultSegmentName.lapsing:
            return LapsedClientsDescription;
        case DefaultSegmentName.prospective:
            return ProspectiveClientsDescription;
        default:
            return '';
    }
};
var getSegmentSetter = function (segmentName, setters) {
    switch (segmentName) {
        case DefaultSegmentName.new:
            return setters.setNewClients;
        case DefaultSegmentName.regular:
            return setters.setRegular;
        case DefaultSegmentName.lapsing:
            return setters.setLapsing;
        case DefaultSegmentName.prospective:
            return setters.setProspective;
        default:
            return function () { };
    }
};
var getSegmentEnabledState = function (segmentName, audienceState) {
    switch (segmentName) {
        case DefaultSegmentName.new:
            return audienceState.newClients.enabled;
        case DefaultSegmentName.regular:
            return audienceState.regular.enabled;
        case DefaultSegmentName.lapsing:
            return audienceState.lapsing.enabled;
        case DefaultSegmentName.prospective:
            return audienceState.prospective.enabled;
        default:
            return false;
    }
};
var shouldShowWeeksSelector = function (segmentName, isEnabled) {
    return segmentName === DefaultSegmentName.new && isEnabled;
};
export var LABELS_BY_NAME = (_a = {},
    _a[DefaultSegmentName.new] = 'New Clients',
    _a[DefaultSegmentName.regular] = 'Regular Clients',
    _a[DefaultSegmentName.lapsing] = 'Lapsed Clients',
    _a[DefaultSegmentName.prospective] = 'Prospective Clients',
    _a);
export var buildDefaultSegments = function (params) {
    var defaultSegments = params.defaultSegments, audienceState = params.audienceState, setNewClients = params.setNewClients, setRegular = params.setRegular, setLapsing = params.setLapsing, setProspective = params.setProspective;
    var setters = { setNewClients: setNewClients, setRegular: setRegular, setLapsing: setLapsing, setProspective: setProspective };
    return (defaultSegments || [])
        .filter(function (segment) {
        // Filter out 'all' segment as it's handled separately
        if (segment.name === DefaultSegmentName.all)
            return false;
        return true;
    })
        .map(function (segment) {
        var isEnabled = getSegmentEnabledState(segment.name, audienceState);
        return {
            title: LABELS_BY_NAME[segment.name],
            description: getSegmentDescription(segment.name),
            value: isEnabled,
            setValue: getSegmentSetter(segment.name, setters),
            clients: segment.customers,
            showWeeksSelector: shouldShowWeeksSelector(segment.name, isEnabled),
        };
    });
};
